import { Box, Stack } from "@mui/material";
import { forwardRef } from "react";
import { Strategy } from "../../../store/slices/strategySlice";
import AutoStrategyCard from "./AutoStrategyCard";
import Spacer from "../../../_components/Spacer";
import EmptyState from "../../../_components/EmptyState/EmptyState";

interface Props {
  strategies: Strategy[];
}

const AutoStrategyList = forwardRef<HTMLDivElement, Props>(({ strategies }, ref) => {
  return (
    <>
      {strategies.length > 0 ? (
        <>
          <Stack direction={"column"} spacing={1} sx={{ width: "100%" }}>
            {strategies.map((strategy, index) => (
              <AutoStrategyCard key={index} strategy={strategy} />
            ))}
          </Stack>

          <Spacer height="75px" />

          <Box
            sx={{
              position: "relative",
              marginBottom: "20px",
              width: "100px",
              height: "30px",
            }}
            className={"observerRef"}
            ref={ref}
          />
        </>
      ) : (
        <Stack direction="row" justifyContent="center" alignItems="center" height="100%" mt="-34px">
          <EmptyState text="Auto-strategies not found" />
        </Stack>
      )}
    </>
  );
});

export default AutoStrategyList;
